/** Default OG/meta payload; lives outside `root.tsx` so route modules/tests avoid importing CSS. */
export const baseMeta = {
  title: 'Clube do Tennis',
  description: 'A comunidade do tenista',
  content_type: 'website',
  image: '/images/share-image.png',
}
